import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { NameFormGroup } from './name-form.helper';

@Component({
  selector: 'app-name-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidatedInputComponent,
    ValidatedDropdownComponent,
    GetLocalizedPipe,
  ],
  templateUrl: './name-form.component.html',
  styleUrl: './name-form.component.scss',
})
export class NameFormComponent {
  protected readonly genericStore = inject(GenericStore);
  formGroup = input.required<FormGroup<NameFormGroup>>();
  /** When true, show the name title dropdown (e.g. Dr., Mr.) bound to titleFormControl. */
  showTitle = input<boolean>(false);
  /** Required when showTitle is true; the parent's title control (e.g. from TitleNameFormGroup). */
  titleFormControl = input<FormControl<string | null> | null>(null);
}
